import keyMirror from 'keymirror'

export default keyMirror({
  RENDER_PROJECTS: null,
  RENDER_ALL_TEAM_PROJECTS: null,
  UPDATE_PROJECTS: null,
  RELOAD_PROJECTS: null,
  RENDER_MORE_PROJECTS: null,
  OPEN_JOB_SETTINGS: null,
  REMOVE_PROJECT: null,
  REMOVE_JOB: null,
  CHANGE_JOB_PASS: null,
  OPEN_JOB_TM_PANEL: null,
  NO_MORE_PROJECTS: null,
  CHANGE_PROJECT_NAME: null,
  HIDE_PROJECT: null,
  ASSIGN_TRANSLATOR: null,
  SHOW_RELOAD_SPINNER: null,
  ADD_SECOND_PASS: null,
  //MODALS
  OPEN_CREATE_TEAM_MODAL: null,
  OPEN_MODIFY_TEAM_MODAL: null,
  OPEN_INFO_TEAMS_POPUP: null,
  //TEAMS
  REMOVE_TEAM: null,
  UPDATE_TEAM_NAME: null,
  UPDATE_TEAM_MEMBERS: null,
  FILTER_PROJECTS: null,
  CHANGE_PROJECT_ASSIGNEE: null,
  CHANGE_PROJECT_TEAM: null,
  SELECTED_TEAM: null,
  ALL_MEMBERS_FILTER: null,
  NOT_ASSIGNED_FILTER: null,

  ENABLE_DOWNLOAD_BUTTON: null,
  DISABLE_DOWNLOAD_BUTTON: null,

  UPDATE_JOB_OUTSOURCE: null,
})
